<template>
    <div>
        <v-autocomplete
                id="type"
                v-model="unit"
                label="Unit of Measure"
                :items="units"
                item-text="name"
                return-object
                :rules="rules"
                @change="$emit('selected', unit)">
        </v-autocomplete>
    </div>
</template>

<script>
    import Recorded from '../Lib/Recorded'

    export default {
        name: "DropdownUnits",
        created() {
            this.getUnits()
        },
        data() {
            return {
                units: [],
                unit: null
            }
        },
        props:{
            rules: {
                default: () => {return []},
            }
        },
        methods: {
            async getUnits() {
                let units = await Recorded.get('/units');
                if (units) {
                    this.units = units.data

                    let grams = this.units.filter(unit => unit.name === "g");
                    if(grams.length > 0){
                        this.unit = grams[0]
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>
